import type { ColumnDef } from "@tanstack/react-table"

import WarehouseRowActions from "../components/WarehousesTable/WarehouseRowActions"
import { getWarehouseTypeLabel } from "../utils"

import { WarehouseStatusCell } from "@/components/table/WarehouseStatusCell"
import { PermissionActionType } from "@/constants/permissions"
import type { WarehouseAreaOutputList } from "@/graphql/codegen/graphql"
import { usePermissionManager } from "@/hooks/usePermissionManager"
import { AddressFormat } from "@/types/common"
import { formatLocationAddress } from "@/utils/utils"

export const useWarehouseColumns = (onRefresh: () => void): ColumnDef<WarehouseAreaOutputList>[] => {
  const { hasPermissions } = usePermissionManager()
  let columns: ColumnDef<WarehouseAreaOutputList>[] = [
    {
      accessorKey: "companyName",
      header: "Company Name",
      enableSorting: true,
      sortingFn: "alphanumeric",
      size: 150,
      cell: ({ row }) => row.original.companyName,
    },
    {
      accessorKey: "address",
      header: "Address",
      enableSorting: true,
      sortingFn: "alphanumeric",
      size: 300,
      cell: ({ row }) => formatLocationAddress(row.original.location, AddressFormat.LocationAndAddress),
    },
    {
      accessorKey: "companyId",
      header: "Company ID",
      enableSorting: true,
      sortingFn: "alphanumeric",
      size: 200,
      cell: ({ row }) => row.original.companyPublicId,
    },
    {
      accessorKey: "warehouseId",
      header: "Warehouse ID",
      enableSorting: true,
      sortingFn: "alphanumeric",
      size: 170,
      cell: ({ row }) => <WarehouseStatusCell warehouse={row.original} />,
    },
    {
      accessorKey: "type",
      header: "Type",
      enableSorting: true,
      sortingFn: "alphanumeric",
      size: 170,
      cell: ({ row }) => getWarehouseTypeLabel(row.original.type!),
    },
  ]

  if (hasPermissions([PermissionActionType.WAREHOUSES_MAINTENANCE])) {
    columns = [
      ...columns,
      {
        accessorKey: "actions",
        header: "",
        enableSorting: false,
        size: 72,
        cell: ({ row }) => <WarehouseRowActions row={row} onRefresh={onRefresh} />,
      },
    ]
  }

  return columns
}
